import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-check-box",
  "use": "svgIcon-check-box-usage",
  "viewBox": "0 0 440.02 440.02",
  "content": "<symbol viewBox=\"0 0 440.02 440.02\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svgIcon-check-box\"><path d=\"m327.327 359.861h-267.327v-267.329h208.65l60.001-60h-328.651v387.328h387.327v-248.014l-60 60.001z\" fill=\"currentColor\" /><path d=\"m125.735 173.171-42.427 42.426 101.85 101.851 254.862-254.863-42.427-42.426-212.435 212.436z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol